<template>
  <div>
    <v-dialog
      v-model="planDialog"
      width="500px">
      <el-form
        ref="form"
        :model="formData"
        :rules="rules">
        <div class="dialog-container">
          <div class="plan-header">
            <div class="info flex">
              <span>New Request</span>
              <i
                class="el-icon-close"
                @click="changeDialog"></i>
            </div>
          </div>
          <div class="dialog-body">
            <div class="flex-content">
              <div class="flex-box">
                <div class="form-item">
                  <span>Remark</span>
                  <el-form-item prop="remark">
                    <v-input
                      v-model="formData.remark"
                      placeholder="Internal remarks"
                      type="textarea"
                      :rows="4" />
                  </el-form-item>
                </div>
                <div class="form-item">
                  <span>Upload Slots</span>
                  <span
                    v-for="(item,index) in formData.file"
                    :key="index"
                    class="flex flex-align">
                    <el-form-item
                      :ref="`file.${index}.name`"
                      :rules="rules.name"
                      :prop="'file.' + index + '.name'">
                      <v-input
                        v-model="item.name"
                        placeholder="Doc Name"
                      ></v-input>
                    </el-form-item>
                    <font-awesome-icon
                      v-if="index!=0"
                      icon="trash-alt"
                      class="hand"
                      @click="handlerDel(index)"></font-awesome-icon>
                  </span>
                  <v-button
                    class="button-width"
                    type="plain"
                    @click="handlerAdd">Add</v-button>

                </div>

              </div>
            </div>
          </div>
          <div class="flex footer-button">
            <v-button @click="changeDialog">Close</v-button>
            <v-button
              type="success"
              @click="ConfirmCoupon">Send</v-button>
          </div>
        </div>
      </el-form>
    </v-dialog>
    <send-email-sms
      ref="send-email-sms"
      :form="form.customer_profile"
      :skip="false"
      :showUsername="true"
      :initContent="form.upload_request_data"
      :emailListTitle="emailListTitle"
      :emailTitle="emailTitle"
      @send="handlerSend" />
  </div>
</template>
<script>
import {mapState} from 'vuex'
import MixinOptions from '@/mixins/options'
import MixinFormat from '@/mixins/format'
import {addUploadRequest} from '@/api/account'
import SendEmailSms from '@/views/components/dialogs/send-email-sms'

export default {
  name: 'uploadRequestDialog',
  components:{
    SendEmailSms
  },
  mixins: [MixinOptions, MixinFormat],
  props: {
    form: {
      type: Object,
      default: () => ({})
    },
    customerData: [String, Number],
  },
  data() {
    return {
      planDialog: false,
      formData:{
        remark:'',
        file:[{name:''}]
      },
      rules: {
        name: [
          { required: true, message: this.$t('placeholder.input'), trigger: ['change', 'blur'] }
        ],
        remark: [
          { required: false, message: this.$t('placeholder.input'), trigger: ['change', 'blur'] }
        ],
      }
    }
  },
  computed: {
    emailTitle(){
      return this.form.upload_request_title || ''
    },
    emailListTitle(){
      return this.form.upload_request_list_title || ''
    }
  },
  watch:{
    form:{
      immediate:true,
      handler(val){
      }
    },
  },
  methods: {
    handlerAdd(){
      this.formData.file.push({name:''})
    },
    handlerDel(index){
      this.formData.file.splice(index,1)
    },
    changeDialog() {
      this.planDialog = !this.planDialog
    },
    ConfirmCoupon(){
      this.$refs.form.validate((valid, rules) => {
        if(valid) {
          this.planDialog =false
          this.$refs['send-email-sms'].changeDialog()
        }
        else {
          // console.log(rules, '======')
        }
      })

    },
    handlerSend(content){
      let params = {
        ...this.formData,
        customer_id: this.customerData,
        file_num:this.formData.file.length,
        content
      }
      this.network().addUploadRequest(params)
    },
    network() {
      return {
        addUploadRequest:async (params)=>{
          let {data} = await addUploadRequest(params)
          this.$parent.addListData(data)
          // this.$emit('upList')
        },
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  ::v-deep .el-dialog{
    border-radius: 4px;
  }
  .dialog-container {
    //padding: 15px;
    border-radius: 5px;
    .plan-header {
      background: #F6F8FA;
      border-top-left-radius: 5px;
      border-top-right-radius: 5px;
      .info{
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding:10px 10px 10px 10px;
        font-size: 14px;
        font-weight: 600;
        color: #24292E;
        i{
          font-weight: 600;
          font-size: 14px;
        }
      }
    }
    .dialog-body{
      padding: 15px;
      max-height: 800px;
      overflow-y: auto;
    }
    .footer-button{
      padding: 15px;
      justify-content: space-between;
    }
    .flex-content {
      //width: 280px;
      .flex-box {
        border-radius: 5px;
        /*border: 1px solid #E1E4E8;*/
        //width: 280px;
        margin: 16px 0;

        .flex-info {
          display: flex;
          justify-content: space-between;
          padding: 23px 15px;
          border-bottom: 1px solid #E1E4E8;

          span:first-child {
            color: #586069;
            font-size: 14px;
            font-weight: 500;
          }

          span:last-child {
            color: #24292E;
            font-size: 14px;
          }
        }


      }

    }
    .flex-align{
      align-items: center;
      margin-bottom: 15px;
      .el-input{
        margin-right: 10px;
        width: 440px;
        input::-webkit-input-placeholder {
          /* placeholder颜色 */
          color: #707175;
          /* placeholder字体大小 */
          font-size: 12px;
        }
      }
    }
    .button-width{
      width: 100%;
    }
    .hand{
      cursor: pointer;
    }

  }
  ::v-deep .el-textarea{
    textarea::-webkit-input-placeholder {
      color: #707175!important;
    }
  }
  ::v-deep .el-input{
    input::-webkit-input-placeholder {
      color: #707175!important;
    }
  }
</style>
